import { groupBy } from 'lodash';
import { FormSelectConfig } from '/@/modules/core/form/models/FormSelectConfig';
import { CountryAdministrativeDivisionDescriptor } from '/@/modules/predefined/enums/CountryAdministrativeDivisionDescriptor';
import { getters } from '/@/modules/core/app/helpers/store';
import JurisdictionService from '/@/modules/predefined/services/JurisdictionService';
import Lang from '/@/modules/core/app/services/Lang';

export class JurisdictionSelectConfig extends FormSelectConfig {
  constructor(config = {}) {
    super({
      placeholder: config.placeholder ?? Lang.t('contact.state'),
      groupValues: 'jurisdictions',
      groupLabel: 'group',
      trackBy: 'id',
      label: 'name',
      ...config
    });
  }

  /**
   * @returns {Array.<Jurisdiction>}
   */
  getOptions(params = {}) {
    if (params.id) {
      this.placeholder =
        CountryAdministrativeDivisionDescriptor.getByKey(params.id).value || this.placeholder;
    }

    if (params.countryId) {
      return this.getGroupedOptions(
        JurisdictionService.getJurisdictionsByCountry(
          params.countryId,
          params.administrativeDivisionDescriptor
        )
      );
    }
    return this.getGroupedOptions(getters.predefined.getJurisdictions());
  }

  /**
   * @param options
   * @param groupKey
   * @returns {Array}
   */
  getGroupedOptions(options, groupKey = 'countryId') {
    const groupData = [];
    Object.entries(groupBy(options, groupKey)).forEach(([type, jurisdictions]) => {
      groupData.push({
        group: getters.predefined
          .getActiveCountries()
          .find((country) => country.id === jurisdictions[0].countryId)?.name,
        jurisdictions
      });
    });
    return groupData;
  }
}
